<template lang="pug">
    .container.content(v-if="edit && contents && contents.length")
        .content-wrap.column.is-offset-1.is-10
            validation-provider(
                ref="content"
                :vid="vid"
                :name="name"
                :rules="rules"
                v-slot="{ errors }"
            )
                .field
                    label.label(v-if="labels.text" v-html="labels.text")
                    quill-editor(
                        ref="quill"
                        v-model="text"
                        :class="{ 'is-danger': errors && errors.length }"
                    )
                    p.help.is-danger.has-text-left(v-if="errors && errors.length") {{ errors[0] }}
                    p.help.has-text-grey.has-text-left(v-else) Pflicht
    .container.content(v-else-if="contents && contents.length")
        .content-wrap.column.is-offset-1.is-10
            .description(v-if="content && content.text" v-html="content.text")
</template>

<script>

import _ from 'lodash'
// import Vue from 'vue'
import { ValidationProvider } from 'vee-validate'

export default {
    name: 'Description',
    props: {
        vid: {
            type: String,
        },
        name: {
            type: String,
            default: '',
        },
        rules: {
            type: [Object, String],
            default: "",
        },

        edit: {
            type: Boolean,
            default: false,
        },
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        ValidationProvider,
    },
    computed: {
        contents() {
            return this.section.contents || []
        },
        content() {
            return this.contents.find(content => content.key === 'content')
        },
        text: {
            get() {
                return this.content.text
            },
            set(value) {
                this.$emit('change', this.section.id, this.content.id, 'text', value)
            }
        },
        labels() {
            let labels = {
                text: _.get(this.content, 'labels.text'),
            }

            return labels
        },
        placeholders() {
            let placeholders = {
                text: _.get(this.content, 'placeholders.text'),
            }

            return placeholders
        },
    },
    mounted() {
        if (this.$refs.quill && this.placeholders.text) {
            this.$refs.quill.quill.root.setAttribute('data-placeholder', this.placeholders.text)
        }
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";

    .content h5
        margin-bottom: 0
    .description
        padding: 12px 0

</style>
